import { render } from "./ChongXiao.vue?vue&type=template&id=7675d508"
import script from "./ChongXiao.vue?vue&type=script&lang=js"
export * from "./ChongXiao.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__